import { is8DataApp } from '../../../utils';
import React from 'react';
import Content8fig from '../../../components/Onboarding/GetStarted/Signup/Signup8fig';
import Content8Data from '../../../components/Onboarding/GetStarted/Signup/Signup8Data';
import SignupProvider from 'frontend/src/components/Onboarding/GetStarted/Signup/SignupProvider';

export default function Signup() {
  return (
    <SignupProvider>
      {is8DataApp() ? <Content8Data /> : <Content8fig />}
    </SignupProvider>
  );
}
